/*
 * @Author: 张斌
 * @Date: 2022-05-05 16:08:19
 * @LastEditors: 张斌
 * @LastEditTime: 2023-11-10 16:47:35
 */
import { commonRequest } from '@/utils/request'

/** 获取部门列表 id */
export function getDepartmentList(params: {
  orgId: string
}) {
  return commonRequest({
    method: 'GET',
    url: '/V1/Admin/Data/OrgDeptList',
    params,
  })
}
/** 添加部门 */
export function addDepartment(data: {
  name: string
  father: string
  orgId: string
  netIds: string[]
}) {
  return commonRequest({
    method: 'POST',
    url: '/V1/Admin/Org/Dept/Add',
    data,
  })
}

/** 生成二维码 */
export function generateQRcode(data: {
  qrcodeName: string[]
  deptId: string
  orgId: string
  type:string
  isV3:boolean
}) {
  return commonRequest({
    method: 'POST',
    url: '/V1/Admin/Org/PosQrCode',
    data,
  })
}
/** 生成二维码 */
export function generateQRcode2(data: {
  qrcodeName: string[]
  deptId: string
  orgId: string
  type:string
  isV3:boolean
}) {
  return commonRequest({
    method: 'POST',
    url: '/V1/Admin/Org/posQrCodeSquare',
    data,
  })
}

export function updData(data: {
  qrcodeId: string
  code: string
 
}) {
  return commonRequest({
    method: 'POST',
    url: '/V1/OrgPos/saveQrCodeByte',
    data,
  })
}
export function getdata(params: {
  qrcodeId: string
}) {
  return commonRequest({
    method: 'GET',
    url: '/V1/OrgPos/getQrcodeByteByQrcodeId',
    params,
  })
}

/** 删除部门 */
export function deleteDepartment(deptId:string) {
  return commonRequest({
    method: 'delete',
    url: `/V1/OrgDept/${deptId}`,
  })
}
/** 修改部门名称和网络 */
export function modifyDepartment(data: {
  netIds: string[]
  deptName: string
  deptId: string
  orgId: string
}) {
  return commonRequest({
    method: 'PUT',
    url: '/V1/Admin/Org/Dept',
    data,
  })
}
